import gsap from "gsap";
(() => {
  const container = document.querySelector("#beforeAfter .images");
  console.log("beforeAfter.js loaded");
  if (!container) return;

  if ("ontouchstart" in window || navigator.maxTouchPoints) {
    container.addEventListener("touchmove", moveCB);
  } else {
    container.addEventListener("mousemove", moveCB);
    container.addEventListener("mouseleave", leaveCB);
    container.addEventListener("mouseenter", enterCB);
  }

  function enterCB(e) {
    clearTimeout(timeout);
  }

  function leaveCB(e) {
    moveCB(e);
    timeout = setTimeout(() => {
      gsap.to(container, {
        "--_percentage": "50%",
      });
    }, 3000);
  }
  function moveCB(e) {
    e.preventDefault();
    const rect = container.getBoundingClientRect();
    let x;
    if (e.type === "touchmove") {
      x = e.touches[0].clientX - rect.left;
    } else {
      x = e.clientX - rect.left;
    }
    const percentage = (x / rect.width) * 100;

    gsap.to(container, {
      "--_percentage": `${Math.min(Math.max(percentage, 0), 100)}%`,
    });
  }

  let timeout;
})();
